import { NavigationExtras, Router } from '@angular/router';

export function closeCurrentOverlay(router: Router, extras?: NavigationExtras) {
  return router.navigate([{ outlets: { o: null } }], extras);
}
